export default __webpack_public_path__ + "static/media/heart-white.d714624b.svg";